import { FULFILLMENT_TYPE } from '../constants/status';
import { OmmAvailableDeliverySlotsApi, OmmAvailableFulfillmentOptionsApi, OmmEditDeliveryAddressAppifyApi, } from '../api/omm/edit-delivery-address';
export var DeliveryInstructionsEdit = function (fulfillmentGroup, orderDetailsData, handleEditDeliveryInstructions, customerType, fulfillmentGroupIndex) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var orderNumber = orderDetailsData.orderNumber, emailId = orderDetailsData.emailId, orderDetailsEt = orderDetailsData.et, orderOrigin = orderDetailsData.orderOrigin, salesDate = orderDetailsData.salesDate, storeNumber = orderDetailsData.storeNumber;
    var fulfillmentType = fulfillmentGroup.fulfillmentType, fulfillmentEt = fulfillmentGroup.et;
    var et = fulfillmentEt !== null && fulfillmentEt !== void 0 ? fulfillmentEt : (orderDetailsEt || '');
    var deliveryInstructions = '';
    var fulfillmentTypeForOMM = '';
    switch (fulfillmentType) {
        case FULFILLMENT_TYPE.DFS:
            fulfillmentTypeForOMM = FULFILLMENT_TYPE.DFS;
            break;
        case FULFILLMENT_TYPE.BODFS:
            fulfillmentTypeForOMM = 'BODFS';
            break;
        case FULFILLMENT_TYPE.MA:
            fulfillmentTypeForOMM = 'MA';
            break;
        default:
            break;
    }
    if (fulfillmentType === FULFILLMENT_TYPE.BODFS || FULFILLMENT_TYPE.DFS) {
        var instructions = (_b = (_a = fulfillmentGroup.bodfsDeliveryAndHandling) === null || _a === void 0 ? void 0 : _a.bodfsDeliveries) === null || _b === void 0 ? void 0 : _b[0].deliveryInstructions;
        deliveryInstructions = instructions || '';
    }
    if (fulfillmentType === FULFILLMENT_TYPE.MA) {
        var instructions = (_d = (_c = fulfillmentGroup.shippingAndHandling) === null || _c === void 0 ? void 0 : _c.applianceDeliveries) === null || _d === void 0 ? void 0 : _d[0].deliveryInstructions;
        deliveryInstructions =
            instructions && instructions.toLowerCase() !== 'no delivery instructions'
                ? instructions
                : '';
    }
    var deliveryInstructionInfo = {
        orderId: orderNumber,
        emailId: emailId,
        et: et,
        deliveryInstructions: deliveryInstructions,
        fulfillmentType: fulfillmentTypeForOMM,
        surveyFulfillmentType: fulfillmentType,
        customerType: customerType,
        orderOrigin: orderOrigin,
        salesDate: salesDate,
        storeNumber: storeNumber === null || storeNumber === void 0 ? void 0 : storeNumber.toString(),
        traceId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId,
        net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
        xAuthGuestToken: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken,
        fulfillmentGroupIndex: fulfillmentGroupIndex,
        isEditSiteInstructionsEnabled: (_e = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _e === void 0 ? void 0 : _e.isEditSiteInstructionsEnabled,
        deliveryType: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.deliveryType,
        previousSiteInstructions: ((_h = (_g = (_f = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _f === void 0 ? void 0 : _f.bodfsDeliveries) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.siteInstructions) ||
            ((_l = (_k = (_j = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _j === void 0 ? void 0 : _j.applianceDeliveries) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.siteInstructions),
    };
    handleEditDeliveryInstructions(deliveryInstructionInfo);
};
export var OmmEditDeliveryAddressAppify = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    return OmmEditDeliveryAddressAppifyApi(request, isAuthTHDUser, xAuthGuestToken, traceId);
};
export var OmmAvailableDeliverySlots = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    return OmmAvailableDeliverySlotsApi(request, isAuthTHDUser, xAuthGuestToken, traceId);
};
export var OmmAvailableFulfillmentOptions = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    return OmmAvailableFulfillmentOptionsApi(request, isAuthTHDUser, xAuthGuestToken, traceId);
};
